import script from "./CorrespondenceQuestionComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./CorrespondenceQuestionComponent.vue?vue&type=script&lang=ts&setup=true"

import "./CorrespondenceQuestionComponent.vue?vue&type=style&index=0&id=4fdfa368&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fdfa368"]])

export default __exports__